<template>
  <div class="product-info" v-if="data && product">
    <div class="area">
      <div
        class="row product-info-container"
        v-animated-show="utils.handleScroll"
      >
        <router-link
          to="/product"
          v-html="data.info.button"
          class="button-back col-6 col-md-12"
        ></router-link>
        <h2 class="title col-6 col-md-12" v-html="product.title"></h2>
        <div class="gallery-container col-6 col-md-12">
          <Gallery
            class
            :list="product.gallery.list"
            :is-catalog="true"
            id="catalog-nav"
          />
        </div>
        <div class="info col-6 col-md-12">
          <Description
            class="small col-6"
            ref="bannerDescription"
            :isMoreTop="true"
            title="Состав"
            :desc="product.desc"
          />
          <h3
            class="col-6 col-md-12"
            v-html="'Энергетическая ценность на 100 грамм'"
          ></h3>
          <table class="nutritions col-4 col-md-12">
            <tr>
              <td>Белки</td>
              <td>{{ product.nutritions.protein }} гр</td>
            </tr>
            <tr>
              <td>Жиры</td>
              <td>{{ product.nutritions.fat }} гр</td>
            </tr>
            <tr>
              <td>Углеводы</td>
              <td>{{ product.nutritions.carbohydrates }} гр</td>
            </tr>
            <tr>
              <td>Калорийность</td>
              <td>{{ product.nutritions.energy }} ккал</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import Gallery from "../containers/Gallery";
export default {
  name: "ProductInfo",
  props: {
    theme: {
      default: "default",
    },
    product: Object,
    data: Object,
  },
  data() {
    return {
      utils: utils,
      current: 0,
    };
  },

  components: { Gallery },
};
</script>

<style lang="scss">
.product-info {
  .button-back {
    @extend %button-back;
    @media all and (max-width: $md) {
      grid-row: 4;
      justify-self: center;
      margin-top: 60px;
    }
  }
  background: $bg-main;
  h2.title {
    @media all and (max-width: $md) {
      margin: 0;
      text-align: center;
    }
    margin: 0;
    margin-left: 26px;
    font-weight: bold;
    @media all and (max-width: $md) {
      font-size: 24px;
    }
  }
  .product-info-container {
    grid-row-gap: 26px;
  }
  @extend %page-block;
  @media all and (max-width: $md) {
    padding-top: 28px;
  }
  padding-top: 34px;
  .info {
    @media all and (max-width: $md) {
      text-align: center;
      margin-left: 0;
    }
    margin-left: 26px;
    display: grid;
    grid-gap: 26px 0;
    align-items: flex-start;
    align-content: flex-start;
    margin-top: 0px;
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .nutritions {
    text-align: center;
    @media all and (max-width: $md) {
      width: 100%;
    }
    tr {
      background-image: linear-gradient(
        to right,
        $text-menu 10%,
        rgba(255, 255, 255, 0) 0%
      );
      background-position: top;
      background-size: 9px 1px;
      background-repeat: repeat-x;
      border: 0;
      &:first-child {
        background: transparent;
        td {
          padding-top: 0px;
        }
      }
      &:last-child {
        td {
          padding-bottom: 0px;
        }
      }
      td {
        padding: 10px 10px 8px 10px;
        &:last-child {
          &::before {
            background: transparent;
          }
        }
        position: relative;
        &::before {
          content: "";
          background-image: linear-gradient(
            to bottom,
            #333 10%,
            rgba(255, 255, 255, 0) 00%
          );
          background-position: left;
          background-size: 1px 9px;
          background-repeat: repeat-y;
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          width: 1px;
        }
      }
    }
  }
}
</style>
